module.exports = __webpack_public_path__ + "static/media/Johnny.ebe20b22.jpg";